import { render } from "./WordDisplay.vue?vue&type=template&id=d4ab9eac"
import script from "./WordDisplay.vue?vue&type=script&lang=js"
export * from "./WordDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/SignSentence/SignSentence/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__